import React, { ReactElement } from 'react'
import AppStandardLayout from '~/components/layout/AppStandardLayout'
import PublicLayout from '~/components/layout/PublicLayout'
import AppSpaceLayout from '~/components/layout/AppSpaceLayout'
import LoginableLayout from '~/components/layout/LoginableLayout'
import SpaceNavigation from '~/components/layout/navigation/SpaceNavigation'
import NavigationPageFrame from '~/components/wrapper/screen/NavigationPageFrame'

/**
 * Next js Layouts
 * https://nextjs.org/docs/basic-features/layouts
 */

export interface LayoutOptions {
  // Public
  isResponsive?: boolean
  // AppSpace
  isSetting?: boolean
  denyGuest?: boolean
}

const defaultLayoutOptions: LayoutOptions = {
  isResponsive: false,
  isSetting: false,
  denyGuest: false,
}

export const getPublicLayout = (page: ReactElement, layoutOptions: LayoutOptions = defaultLayoutOptions) => {
  return (
    <PublicLayout isResponsive={layoutOptions.isResponsive ?? false}>
      {page}
    </PublicLayout>
  )
}

export const getLoginableLayout = (page: ReactElement, layoutOptions: LayoutOptions = defaultLayoutOptions) => {
  return (
    <LoginableLayout isResponsive={layoutOptions.isResponsive ?? false}>
      {page}
    </LoginableLayout>
  )
}

export const getAppStandardLayout = (page: ReactElement) => {
  return (
    <AppStandardLayout>
      {page}
    </AppStandardLayout>
  )
}

export const getAppSpaceLayout = (page: ReactElement, layoutOptions: LayoutOptions = defaultLayoutOptions) => {
  return (
    <AppSpaceLayout isSetting={layoutOptions.isSetting ?? false} denyGuest={layoutOptions.denyGuest ?? false}>
      {page}
    </AppSpaceLayout>
  )
}

export const getAppSpaceNavigationLayout = (page: ReactElement, layoutOptions: LayoutOptions = defaultLayoutOptions) => {
  return (
    <AppSpaceLayout isSetting={layoutOptions.isSetting ?? false} denyGuest={layoutOptions.denyGuest ?? false}>
      <NavigationPageFrame>
        <SpaceNavigation/>
        {page}
      </NavigationPageFrame>
    </AppSpaceLayout>
  )
}
